import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = [
    "valuesContainer",
    "sectionsContainer",
    "metaTitle",
    "metaTitleCount",
    "previewTitle",
    "metaDesc",
    "metaDescCount",
    "previewDesc",
  ];

  connect() {
    this.updateMetaTitleCounter();
    this.updateMetaDescCounter();
  }

  addValue() {
    const template = document
      .getElementById("value-template")
      .content.cloneNode(true);
    this.valuesContainerTarget.appendChild(template);
  }

  removeValue(event) {
    event.target.closest(".value-item").remove();
  }

  addSection() {
    const template = document
      .getElementById("section-template")
      .content.cloneNode(true);
    this.sectionsContainerTarget.appendChild(template);
  }

  removeSection(event) {
    event.target.closest(".section-item").remove();
  }

  updateMetaTitleCounter() {
    const length = this.metaTitleTarget.value.length;
    this.metaTitleCountTarget.textContent = `${length}/60`;
    this.previewTitleTarget.textContent =
      this.metaTitleTarget.value || document.querySelector("h1").textContent;
  }

  updateMetaDescCounter() {
    const length = this.metaDescTarget.value.length;
    this.metaDescCountTarget.textContent = `${length}/160`;
    this.previewDescTarget.textContent =
      this.metaDescTarget.value ||
      "Add a description to improve your search results.";
  }
}
